/* Publish by EComposer at 2026-10-12 13:26:39*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-1svb4ahpl9p"]=  window.__ectimmers["ecom-1svb4ahpl9p"] || {};
let t=this.$el;if(!!t)for(const e of t.querySelectorAll('[data-ecom-el-role="item"]')){let i=e.querySelector('[data-ecom-el-role="copy"]'),o=e.querySelector('[data-ecom-el-role="code"]');if(!i||!o||!o.textContent)continue;let n=o.textContent;i.addEventListener("click",s=>{s.preventDefault(),i.disabled="disabled",!i.classList.contains("ecom-copied")&&(async()=>{try{await navigator.clipboard.writeText(n),i.classList.add("ecom-copied")}catch(r){console.error("Failed to copy: ",r),i.removeAttribute("disabled")}})()})}

                    });
                    
                        document.querySelectorAll('.ecom-1svb4ahpl9p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1svb4ahpl9p', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-remvcwavwjr"]=  window.__ectimmers["ecom-remvcwavwjr"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const o=t.querySelector(".ecom__element--button");if(!o)return;let n=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-remvcwavwjr"]["qah5dfdyp"] = setInterval(function(){o.classList.add("animated"),setTimeout(function(){o.classList.remove("animated")},s)},n)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let o=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const n=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},o);try{Shopify.analytics.publish("ec_custom_events",n)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-remvcwavwjr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-remvcwavwjr', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3m7vpi9sxfx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3m7vpi9sxfx', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-65kb4mi9e32').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-65kb4mi9e32', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-riq2td0z72r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-riq2td0z72r', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9j81o9fyddo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9j81o9fyddo', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r0620epevyf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r0620epevyf', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rs5a3hjjg7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rs5a3hjjg7', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wo5eu9mm5z').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wo5eu9mm5z', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5u4u4ra9m7s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5u4u4ra9m7s', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m9rvwfx29xm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m9rvwfx29xm', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ll1i1yhvde').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ll1i1yhvde', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2cnuttqw648').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2cnuttqw648', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-inme5mejvkp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-inme5mejvkp', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iiw7upah2hb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iiw7upah2hb', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-08ajag7pkoip').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-08ajag7pkoip', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nrgyu5cs40n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nrgyu5cs40n', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zgc2owhjl3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zgc2owhjl3', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eki4u49d38k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eki4u49d38k', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p5v2l7barrl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p5v2l7barrl', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3eplw4roegj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3eplw4roegj', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kd4etl2lhrl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kd4etl2lhrl', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hd5vndm9zdo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hd5vndm9zdo', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4ui02l4kuop').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4ui02l4kuop', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6svfey1ddzl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6svfey1ddzl', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tx4hyw1yijg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tx4hyw1yijg', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-jqr6m7leyy"]=  window.__ectimmers["ecom-jqr6m7leyy"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-jqr6m7leyy"]["3s66rreha"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let o=this.$el;if(!o)return;function n(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function s(){let r=o.querySelector(".ecom-element.ecom-base-image"),a=o.closest(".core__row--columns");r&&(n(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){s()})

                    });
                    
                        document.querySelectorAll('.ecom-jqr6m7leyy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jqr6m7leyy', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e81hsnqii3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e81hsnqii3', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l1q3f2wawu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l1q3f2wawu', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ke6imek57j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ke6imek57j', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c39xsa6gfdq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c39xsa6gfdq', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pr53k2y61vc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pr53k2y61vc', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vfkakuaty4f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vfkakuaty4f', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-99yepmf3gzj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-99yepmf3gzj', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m4cdmekcxuk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m4cdmekcxuk', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dn3yr71xmio').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dn3yr71xmio', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-amy23zeo3j7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-amy23zeo3j7', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9l23cizom58').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9l23cizom58', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nsru3x64uk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nsru3x64uk', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vbverna96ks').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vbverna96ks', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y51fn42e8je').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y51fn42e8je', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7yn57ri0a19').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7yn57ri0a19', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g7l9pwr0xo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g7l9pwr0xo', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o0m2u1gnn8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o0m2u1gnn8', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sa0oz0mndt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sa0oz0mndt', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8dtzuf1dr9k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8dtzuf1dr9k', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kmvea30i2f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kmvea30i2f', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pxgmi16utx8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pxgmi16utx8', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8eeglkto7xo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8eeglkto7xo', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eaw2orwprcm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eaw2orwprcm', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b4w2ckp4qim').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b4w2ckp4qim', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vjpafj2pj6n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vjpafj2pj6n', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pno13yyhk5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pno13yyhk5', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vgirql4i0dj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vgirql4i0dj', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-btqighlkcxc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-btqighlkcxc', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-paaemmko5ns').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-paaemmko5ns', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8wsh3x6jk3h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8wsh3x6jk3h', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-93lq1hdzr4u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-93lq1hdzr4u', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8iahworciod').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8iahworciod', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5hka575xyps').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5hka575xyps', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rbwe9u5wp3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rbwe9u5wp3', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}